import axios from 'axios'

var baseUrl = process.env.REACT_APP_API_URL

var headers = {
  'X_API_Tenant': 'evantaconnect',
  'Content-Type': 'application/json',
}

var unauthApi = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  headers: headers,
})

var createAuthApi = function (authHeaders) {
  const allHeaders = {
    ...headers,
    ...authHeaders,
  }
  return axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    headers: allHeaders,
  })
}

export { unauthApi, createAuthApi, baseUrl }
